import {
  Button,
  Card,
  Heading,
  Paragraph,
  Tag,
} from "@digdir/designsystemet-react";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { cn } from "@/utils";

export const TestområdeLenke = ({ className }: { className?: string }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <Tag
        className={cn(
          "bg-balder-support-surface-tinted! text-balder-text-support-default!",
          className,
        )}
      >
        {t("pages.validering.tag")}
      </Tag>
      <Heading>{t("pages.validering.tittel")}</Heading>
      <Paragraph>{t("pages.validering.lenke-description")}</Paragraph>
      <Button variant="secondary" asChild className="w-fit">
        <Link to={"/maalerdata/validering"}>{t("pages.validering.link")}</Link>
      </Button>
    </Card>
  );
};
